import React from 'react';
import { motion } from 'framer-motion';
const properties = [{
  id: 'hotels',
  title: 'Hotels',
  count: '2,340 properties',
  image: 'https://cdn.magicpatterns.com/patterns/figma-images/KQjsCt6uAqQCgG74ASfCLu/84-21.png'
}, {
  id: 'villas',
  title: 'Villas',
  count: '1,120 properties',
  image: 'https://cdn.magicpatterns.com/patterns/figma-images/KQjsCt6uAqQCgG74ASfCLu/84-22.png'
}, {
  id: 'apartments',
  title: 'Apartments',
  count: '3,780 properties',
  image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=800&q=80'
}];
export function PropertyTypes() {
  return <section id="properties" className="py-20 bg-white" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="text-center mb-12" data-id="element-222">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-italiana text-luxury-slate mb-4" data-id="element-223">
            Browse by Property Type
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="h-1 bg-luxury-blue mx-auto rounded-full" data-id="element-224" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-225">
          {properties.map((property, index) => <motion.div key={property.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -10
        }} className="group cursor-pointer rounded-xl overflow-hidden shadow-soft hover:shadow-float transition-all duration-300 bg-white border border-gray-100" data-id="element-226">
              <div className="relative h-64 md:h-80 overflow-hidden" data-id="element-227">
                <motion.img src={property.image} alt={property.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-228" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-229" />

                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-230">
                  <h3 className="text-2xl font-poppins font-semibold text-white mb-1" data-id="element-231">
                    {property.title}
                  </h3>
                  <p className="text-white/80 text-sm font-medium" data-id="element-232">
                    {property.count}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}